import './LeftPaneNavigation.css';
import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { LeftPaneContext } from './LeftPaneContext';
import { LeftPaneSelectedTab } from '../../../constants';

interface ErrorBadgeProps {
  errorCount: number;
}

const ErrorBadge: FC<ErrorBadgeProps> = observer(({errorCount}) => {
  const hasErrors = errorCount > 0;
  return (
    <div
      className={ cx('ml_validator_error_badge', {
        valid: errorCount === 0
      }) }
    >
      { !hasErrors && <div className="fas fa-check"></div> }
      { hasErrors && errorCount }
    </div>
  );
});

export const LeftPaneNavigation: FC = observer(() => {
  const {
    library,
    isRunning,
    selectedTab,
    setSelectedTab,
  } = React.useContext(LeftPaneContext);
  const [shouldShowBadge, setShouldShowBadge] = React.useState(false);
  const currentApplication = library.currentApplication;
  const errorCount = currentApplication?.validationErrorCount || 0;

  useEffect(() => {
    if (errorCount > 0 && !shouldShowBadge) {
      setShouldShowBadge(true);
    }
  }, [currentApplication?.validationErrorCount]);

  useEffect(() => {
    if (isRunning) {
      setSelectedTab(LeftPaneSelectedTab.TREE_VIEW);
    }
  }, [isRunning]);

  const selectTab = (tab: LeftPaneSelectedTab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="left-pane-navigation">
      <button
        className={ cx('show_tree_view_button', 'left-pane-navigation-button', {
          'left-pane-navigation-button-selected': selectedTab === LeftPaneSelectedTab.TREE_VIEW
        }) }
        onClick={ () => selectTab(LeftPaneSelectedTab.TREE_VIEW) }
        disabled={ isRunning }
      >
        Tree View
      </button>
      <button
        className={ cx('show_error_console_button', 'left-pane-navigation-button', {
          'left-pane-navigation-button-selected': selectedTab === LeftPaneSelectedTab.ERRORS
        }) }
        onClick={ () => selectTab(LeftPaneSelectedTab.ERRORS) }
        disabled={ isRunning }
      >
        Warnings
        {shouldShowBadge && <ErrorBadge errorCount={ errorCount }/>}
      </button>
    </div>
  );
});